import { Container, Navbar } from "react-bootstrap";
import classes from "./NavBar.module.css";

function NavBar() {
  /**
   * SPoRT navigation bar to go at the top of the main page and splash pages.
   * @param : None
   * @returns: navigation bar JSX component with SPoRT icon (linked to SPoRT home page) and page title text
   */

  return (
    <Navbar className={`${classes["navbar-sport-light"]}`}>
      <Container>
        <Navbar.Brand href="https://weather.ndc.nasa.gov/sport/" target="_blank" className="" style={{ marginLeft: "0rem" }}>
          <img alt="NASA SPoRT Logo" src={require("../../../assets/sportLogoHQ.png")} className={classes["navbar-logo"]}/>
        </Navbar.Brand>

        <Navbar.Text className={`${classes["navbar-text"]}`} style={{ marginLeft: "-3.25rem" }}>
          <span className={classes["app-name"]}>SPoRT Training Pages </span>
        </Navbar.Text>
      </Container>
    </Navbar>
  );
}

export default NavBar;